
import React from "react";
import ValorisationPageLayout from '@/components/valorisation/ValorisationPageLayout';
import ValoGuideContent from '@/components/valoguide/ValoGuideContent';
import ValoGuideGallery from '@/components/valoguide/ValoGuideGallery';
import ValoGuideNews from '@/components/valoguide/ValoGuideNews';
import ValoGuideServices from '@/components/valoguide/ValoGuideServices';
import ValoGuideCTA from '@/components/valoguide/ValoGuideCTA';
import { getValoGuideStructuredData, getBreadcrumbItems } from '@/components/valoguide/ValoGuideData';

const ValoGuide = () => {
  const structuredData = getValoGuideStructuredData();
  const breadcrumbItems = getBreadcrumbItems();

  return (
    <ValorisationPageLayout
      title="ValoGuide - Guide de Valorisation des Déchets | Groupe Fabre Environnement"
      description="Découvrez notre guide complet de valorisation des déchets avec conseils pratiques, galerie photos d'actualités et innovations du secteur environnemental."
      canonical="/valoguide"
      keywords="valorisation déchets, guide recyclage, photos sites, innovation environnement, Groupe Fabre, conseils tri, gestion déchets"
      structuredData={structuredData}
      heroTitle="ValoGuide"
      heroSubtitle="Votre guide complet pour la valorisation des déchets"
      breadcrumbItems={breadcrumbItems}
    >
      <ValoGuideContent />
      <ValoGuideGallery />
      <ValoGuideNews />
      <ValoGuideServices />
      <ValoGuideCTA />
    </ValorisationPageLayout>
  );
};

export default ValoGuide;
